export const getCRIDFromMessage = (message = '') => {
  return message.match(/\d/g).join('')
}
